import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type PasswordPolitics = {
  digit: number;
  lowercase: number;
  min: number;
  special: number;
  uppercase: number;
};

export type HierarchyLabels = {
  cliente: string;
  conjunto: string;
  local: string;
  unidade: string;
  default: boolean;
};

export type PrioritySLATimes = {
  firstAttendance: number;
  startProgress: number;
  completion: number;
};

export type PrioritySLA = {
  low: PrioritySLATimes;
  medium: PrioritySLATimes;
  high: PrioritySLATimes;
};

export type TicketNotificationRecipient = "team" | "teamSupervisor" | "responsible" | "requester";
export type TicketNotificationEvent =
  | "opened"
  | "accepted"
  | "approved"
  | "rejected"
  | "inProgress"
  | "completed"
  | "canceled"
  | "closed"
  | "reopened"
  | "deadlineReached"
  | "priorityChanged"
  | "commented";
export type TicketNotifications = {
  events: Record<TicketNotificationEvent, TicketNotificationRecipient[]>;
};

class Companies {


  getAllTags = async (body: AuthBodyType) => {
    try {
      const data = await api.post("/empresa/getUserTags", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createNewUserTag = async (body: AuthBodyType & { empresa: string; nome: string }) => {
    try {
      const data = await api.post("/empresa/novaUserTag", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error;
      }
    }
  };

  deleteUserTag = async (body: AuthBodyType & { empresa: string; id: string }) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/deleteUserTag", {
        ...body,
      });
      return data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getAllFuncionalities = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/getAllFuncionalities", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  editPermissions = async (body: AuthBodyType & { empresa: string; permissionsArray: string[] | []; perfil: string }) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/editPermissions", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getAllPoliticaSenha = async (body: AuthBodyType & { empresa: string }) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/getAllPoliticaSenha", {
        ...body,
      });
      return data.data.passwordPolitics;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  editaPoliticaSenha = async (body: AuthBodyType & { empresa: string; update: PasswordPolitics }) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/editaPoliticaSenha", {
        ...body,
      });
      return data.data.passwordPolitics;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        error.response?.data as unknown as any;
      }
    }
  };

  getHierarchyLabels = async (body: AuthBodyType & { empresa: string }) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/getHierarchyLabels", {
        ...body,
      });
      return data.data.hierarchyLabels;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  editHierarchyLabel = async (body: AuthBodyType & { empresa: string; labels: HierarchyLabels }) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/editHierarchyLabel", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  atualizar = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/atualizar", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  ligaDesligaMigracao = async (body: AuthBodyType, migrado: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/ligaDesligaMigracao", {
        ...body,
        migrado,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  checaAcessoPlanoDeAcao = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/checaAcessoPlanoDeAcao", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  concedeRetiraAcessoPlanoDeAcao = async (body: AuthBodyType, planoDeAcao: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/concedeRetiraAcessoPlanoDeAcao", {
        ...body,
        planoDeAcao,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  concedeRetiraPermissaoLogin = async (body: AuthBodyType, empresaId: string, concedeAcesso: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/concedeRetiraPermissaoLogin", {
        ...body,
        empresaId,
        concedeAcesso,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getById = async (body: AuthBodyType, empresa: string) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/getById", {
        ...body,
        empresa,
      });
      return data.data.info;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  changePrioritySLA = async (body: AuthBodyType, prioritySLA: PrioritySLA | null) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/changePrioritySLA", {
        ...body,
        prioritySLA,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  changeTicketNotifications = async (body: AuthBodyType, ticketNotifications: TicketNotifications) => {
    try {
      const data: AxiosResponse = await api.post("/empresa/changeTicketNotifications", {
        ...body,
        ticketNotifications,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
}

export default Companies;
